// src/config.js
import { createClient } from '@supabase/supabase-js';

// Supabase Configuration
// It's best practice to use environment variables for these, especially for production builds.
// For Create React App, they must start with REACT_APP_
export const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || "https://hrlqnbzcjcmrpjwnoiby.supabase.co";
export const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhybHFuYnpjamNtcnBqd25vaWJ5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTUzOTczODYsImV4cCI6MjA3MDk3MzM4Nn0.sOt8Gn2OpUn4dmwrBqzR2s9dzCn6GxqslRgZhlU7iiE";

// Create and export the supabase client
export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

// API Configuration
// Using a relative path is best for Vercel deployments as it works seamlessly.
export const API_BASE_URL = "/api";

// Admin Configuration
export const ADMIN_API_BASE_URL = "/api/admin";

// Notification Configuration
export const NOTIFICATION_API_URL = "/api/notify-shareholders";

// Dataroom Configuration
export const DATAROOM_API_URL = "/api/dataroom";

// Export commonly used constants
export const APP_NAME = "Kapitalized";
export const APP_VERSION = "1.0.0";

// Environment detection
export const isDevelopment = process.env.NODE_ENV === 'development';
export const isProduction = process.env.NODE_ENV === 'production';

// Configuration object for backward compatibility
const config = {
  SUPABASE_URL,
  SUPABASE_ANON_KEY,
  supabase,
  API_BASE_URL,
  ADMIN_API_BASE_URL,
  NOTIFICATION_API_URL,
  DATAROOM_API_URL,
  APP_NAME,
  APP_VERSION,
  isDevelopment,
  isProduction
};

export default config;